import React from "react";
import { Avatar, AvatarProps } from "@mantine/core";
import { IconBallBasketball } from "@tabler/icons-react";
import { LEAGUE } from "../../models/NBA";
import { useLeague } from "../../context/LeagueContext";
import { getPlayerHeadshotUrl, getPlayerInitials } from "../../utils/player";

export interface PlayerAvatarProps extends Omit<AvatarProps, "src"> {
  playerId?: string | number | null;
  playerName?: string | null;
  league?: LEAGUE | string;
}

export const PlayerAvatar: React.FC<PlayerAvatarProps> = ({
  playerId,
  playerName,
  league,
  size = 36,
  radius = "xl",
  styles,
  children,
  ...props
}) => {
  let contextLeague: LEAGUE | undefined;
  try {
    const ctx = useLeague();
    contextLeague = ctx.league;
  } catch {
    contextLeague = undefined;
  }

  const effectiveLeague = league || contextLeague || LEAGUE.NBA;
  const headshotUrl = getPlayerHeadshotUrl(playerId, effectiveLeague);
  const initials = getPlayerInitials(playerName);

  return (
    <Avatar
      src={headshotUrl}
      alt={playerName || "Player"}
      size={size}
      radius={radius}
      color="dark"
      styles={{
        placeholder: {
          backgroundColor: "#25262b",
          color: "#ced4da",
          fontWeight: 600,
          fontSize: typeof size === "number" ? Math.max(10, Math.floor(size * 0.35)) : 12,
        },
        ...(typeof styles === "object" ? styles : {}),
      }}
      {...props}
    >
      {children || initials || <IconBallBasketball size={typeof size === "number" ? Math.floor(size * 0.5) : 18} />}
    </Avatar>
  );
};

export default PlayerAvatar;
